import React, {useEffect} from 'react';
import styled from 'styled-components';
import {connect, useDispatch} from 'react-redux';
import {
    getContextRoot,
    getLanguageValue,
    navigateToPath
} from "../../common/functions";
import Button from '@material-ui/core/Button';
import {ACTIONS} from '../../redux/actions';
import lodashGet from 'lodash/get';
import DoneIcon from '@material-ui/icons/Done';
import {useLocation} from "react-router-dom";

function RegisterGroupSuccessComponent(props) {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const dispatch = useDispatch();

    const {actions} = props;

    useEffect(function() {
        actions.setActiveStage(2);

        const sessionStoredAmount =
            sessionStorage.getItem('googleAdsPurchaseAmount');
        const localStoredAmount =
            localStorage.getItem('googleAdsPurchaseAmount');
        const storedAmount = Number(
            sessionStoredAmount || localStoredAmount
        );
        const formId =
            params.get('form_id') || props.groupKey;

        console.group('[Google Ads][Group Success] Purchase debug');
        console.log('Conversion data:', {
            href: window.location.href,
            formId,
            sessionStoredAmount,
            localStoredAmount,
            storedAmount,
            gtagType: typeof window.gtag,
            dataLayerAvailable: Array.isArray(window.dataLayer)
        });

        if (!Number.isFinite(storedAmount) || storedAmount <= 0) {
            console.warn('Conversion not sent: invalid purchase value.');
            console.groupEnd();
            return;
        }

        if (!formId) {
            console.error('Conversion not sent: transaction_id missing.');
            console.groupEnd();
            return;
        }

        if (typeof window.gtag !== 'function') {
            console.error('Conversion not sent: gtag unavailable.');
            console.groupEnd();
            return;
        }

        const conversionData = {
            send_to: 'AW-16955488633/dZOuCKbCibAaEPnygJU_',
            value: storedAmount,
            currency: 'USD',
            transaction_id: String(formId)
        };

        let callbackExecuted = false;
        let requestDetected = false;
        let observer = null;

        try {
            observer = new PerformanceObserver(function(list) {
                list.getEntries().forEach(function(entry) {
                    const url = entry.name || '';
                    if (
                        url.includes('googleadservices.com') ||
                        url.includes('googlesyndication.com') ||
                        url.includes('/pagead/conversion') ||
                        url.includes('/pagead/1p-conversion') ||
                        url.includes('google.com/pagead')
                    ) {
                        requestDetected = true;
                        console.log(
                            '✅ Google Ads network request detected:',
                            url
                        );
                    }
                });
            });

            observer.observe({
                type: 'resource',
                buffered: true
            });
        } catch (error) {
            console.warn('PerformanceObserver unavailable:', error);
        }

        console.log('Sending conversion:', conversionData);

        window.gtag('config', 'AW-16955488633');
        window.gtag('event', 'conversion', {
            ...conversionData,
            event_callback: function() {
                callbackExecuted = true;
                console.log('✅ Google Ads event_callback executed.');
                sessionStorage.removeItem('googleAdsPurchaseAmount');
                localStorage.removeItem('googleAdsPurchaseAmount');
                console.log('✅ Stored amount cleared after callback.');
                if (observer) observer.disconnect();
            },
            event_timeout: 5000
        });

        console.log('✅ Conversion command passed to gtag.');

        setTimeout(function() {
            if (!callbackExecuted) {
                console.error(
                    '❌ Google Ads callback did not execute within 6 seconds.'
                );
            }
            if (!requestDetected) {
                console.warn(
                    '⚠️ No Google Ads network request detected. Check Network for pagead or conversion.'
                );
            }
            console.log('Final dataLayer:', window.dataLayer);
            if (observer) observer.disconnect();
            console.groupEnd();
        }, 6000);
    }, []);

    const displayedFormId =
        params.get('form_id') || props.groupKey;

    return (
        <RegisterGroupSuccessStyle>
            <h1>
                {getLanguageValue(
                    'register-individual.stageSuccess-completed-successfully-title'
                )}
            </h1>

            <div className="content-container">
                <DoneIcon className="icon-component"/>

                <span className="completed-successfully-subtext">
                    {getLanguageValue(
                        'register-group.stageSuccess-completed-successfully-subtext'
                    )}
                </span>

                <br/><br/>

                <span>
                    {getLanguageValue(
                        'register-group.stageSuccess-your-form-number'
                    )}
                    {String(displayedFormId || '').toUpperCase()}
                </span>

                {false && (
                    <>
                        <br/><br/>
                        <Button
                            className="check-status-button"
                            onClick={checkStatus}
                        >
                            {String(displayedFormId || '').toUpperCase()}
                        </Button>
                    </>
                )}
            </div>
        </RegisterGroupSuccessStyle>
    );

    function checkStatus() {
        dispatch({
            type: ACTIONS.GENERIC_SET_VALUE,
            payload: [{
                path: 'globalControls.refreshGroupData',
                value: true
            }]
        });

        navigateToPath(
            dispatch,
            getContextRoot() + 'register-visa-for-group/status'
        );
    }
}

const RegisterGroupSuccessStyle = styled.div`
  width: 80%;
  margin: 0 auto;

  .content-container {
    margin-bottom: 25px;
  }

  .icon-component,
  .completed-successfully-subtext {
    vertical-align: middle;
  }

  .check-status-button {
    border: 1px solid black;
  }
`;

const RegisterGroupSuccess = connect(
    function(state) {
        return {
            languageKey: state.languageKey,
            groupKey:
                lodashGet(
                    state,
                    'registerGroupStagesData.key'
                ) || ''
        };
    },
    {}
)(RegisterGroupSuccessComponent);

export default RegisterGroupSuccess;
